import * as React from "react";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import { CardActionArea } from "@mui/material";
import { ArrowSmRightIcon } from "@heroicons/react/outline";
export default function ActionAreaCard() {
  const pageRedirect=()=>{
    window.open(
      "https://www.tcs.com/service-desk-support-transformation-improve-cx#:~:text=TCS%20Solution,grade%20experience%20for%20enterprise%20support.",
      "_blank"
    );
   }
  return (
    <Card
    className="exc border"
      style={{  boxShadow: "8px 8px 2px lightblue" }}
    >
      <CardActionArea>
        <CardContent>
          <Typography
            gutterBottom
            variant="h5"
            component="div"
            className="text"
            style={{  fontSize: "32px", fontWeight: "bold" }}
          >
            Project Experience
          </Typography>

          <Typography
            gutterBottom
            variant="p"
            component="div"
            className="text"
            style={{ fontSize: "24px", fontWeight: "bold" }}
          >
            1. ChatBot Solution 
          </Typography>
          <Typography
            variant="body2"
            color="text.secondary"
            className="text"
            style={{ fontSize: "16px" }}
          >
            It is solution leverages artificial intelligence (AI) and natural
            language processing(NLP) to offer a consumer-grade experience for
            enterprise support. Through an intelligent , predictive , suggestive
            and contextual model (IPSC), the solution drives contextualization
            and personalization at scale and predict users support needs.
          </Typography>
          <p className="text-[#17A6DB] dark:text-[#30dada] flex  text-[16px] py-4 px-4  md:text-[18pxl] lg:text-[20px] cursor-pointer" onClick={pageRedirect}>
          ChatBot Solution Url.<ArrowSmRightIcon className="w-5 ml-2" /> </p>
          <Typography
            gutterBottom
            variant="p"
            component="div"
            className="text"
            style={{  fontSize: "24px", fontWeight: "bold" }}
          >
            2 .ChatBot Solution ANAYTICS DASHBOARD
          </Typography>
          <Typography
            variant="body2"
            color="text.secondary"
            className="text"
            style={{fontSize: "16px" }}
          >
            This is data analytics platform works by supporting data intensive
            applications and could simultaneously support the clusters of
            hardware. They work by using a set of general primitives in order to
            perform the analysis on a real-time basis
          </Typography>
        </CardContent>
      </CardActionArea>
    </Card>
  );
}
